import mustache from 'mustache';

import Sortable from "sortablejs";
import OnSpill from 'sortablejs';
import { AutoScroll } from 'sortablejs';

// Sortable.mount(OnSpill);

import { getAllFeatureFlags, getCookie, hide_tooltips, initializeTooltips, meter_to_mi, sec_to_timeStrCOLON, setCookie, titleCase_withStates } from "../util/general_util";
import { Campground_Data, Trip_Cluster_v2, Trip_leg_v2, Trip_v2 } from "../util/tripPlanner_types";
import { init_postSearch_listeners } from "./eventListeners/postSearch";
import { clearLayer, enlargeIcon, getStopMarker_fromStopID, shrinkIcon } from "./map/helper_functions";
import { center_map, displayRoute, displayStayPins, displayStopPins } from "./map/map_displays";
import { reorderTabStop } from './templates';
import { getTripHTML, reorder_stops, send_removeStay, send_updateTripWishes } from './api_utils';
import { remove_stay_from_stop } from './update_trip_utils';
import { display_potential_stays, hide_map_loadingIcon, show_map_loadingIcon } from './ui_utils';
import { init_date_pickers, show_dates_warnings } from './dates_scripts';
import { get_stop_from_stopID } from './util/helper_functions';
import { remove_avoid_area } from './trip_utils';

function display_driveTimeDist(trip:Trip_v2) {
    if (trip.filters.dist_unit == "km") {
        $("#tripDist").html(Math.round(trip.directions.routes[0].summary.distance/1000).toString());
    } else {
        $("#tripDist").html(Math.round(meter_to_mi(trip.directions.routes[0].summary.distance)).toString());
    };
    $("#tripDriveTime").html(sec_to_timeStrCOLON(trip.directions.routes[0].summary.duration));

    let nStops:number = 0;
    for (let i:number=0;i<trip.legs.length;i++){nStops+=trip.legs[i].clusters.length};
    let totalDist:number;
    if (trip.filters.dist_unit == "km") {
        totalDist = trip.directions.routes[0].summary.distance / 1000;
    } else {
        totalDist = meter_to_mi(trip.directions.routes[0].summary.distance);
    };

    $("#avgDriveDist").html(Math.round(totalDist / (nStops - 1)).toString());

    const drive_dist_displays = $("[drive_dist]");
    const drive_time_displays = $("[drive_time]");

    const segments = trip.directions.routes[0].segments;

    if (trip.filters.dist_unit == "km") {
        $("[drive_dist_unit_label]").html("km");

        $('label[for="poi-rad-5"]').html("5 km");
        $('label[for="poi-rad-20"]').html("20 km");
        $('label[for="poi-rad-30"]').html("30 km");
        $('label[for="poi-rad-40"]').html("40 km");
    } else {
        $("[drive_dist_unit_label]").html("mi");
    }

    let segments_handled = 0;
    for (let i:number = 0; i < trip.legs.length; i++) {
        for (let j:number = 0; j < trip.legs[i].clusters.length; j++) {
            if (segments_handled >= segments.length || segments_handled >= drive_dist_displays.length || segments_handled >= drive_time_displays.length) return;

            const stop = trip.legs[i].clusters[j];
            const hasStay = stop.selectedCamps.length > 0;
            if (hasStay) {
                let stop_sum_dist = 0, stop_sum_dur = 0;
                for (let k:number = 0; k < stop.selectedCamps.length; k++) {
                    if (segments_handled >= segments.length || segments_handled >= drive_dist_displays.length || segments_handled >= drive_time_displays.length) return;

                    const segment = segments[segments_handled];
                    const semgent_dist_m:number = segment.distance;
                    const segment_duration_s:number = segment.duration;

                    if (trip.filters.dist_unit == "km") {
                        drive_dist_displays[segments_handled].innerHTML = Math.round(semgent_dist_m/1000).toString();
                    } else {
                        drive_dist_displays[segments_handled].innerHTML = Math.round(meter_to_mi(semgent_dist_m)).toString();
                    };
                    drive_time_displays[segments_handled].innerHTML = sec_to_timeStrCOLON(segment_duration_s);

                    stop_sum_dist += semgent_dist_m;
                    stop_sum_dur += segment_duration_s;

                    segments_handled += 1;
                };
                if (trip.filters.dist_unit == "km") {
                    $(`[drive_dist_stop][stopID="${stop.stopID}"]`).html(Math.round(stop_sum_dist/1000).toString());
                } else {
                    $(`[drive_dist_stop][stopID="${stop.stopID}"]`).html(Math.round(meter_to_mi(stop_sum_dist)).toString());
                };
                $(`[drive_time_stop][stopID="${stop.stopID}"]`).html(sec_to_timeStrCOLON(stop_sum_dur));
            } else {
                const segment = segments[segments_handled];
                const semgent_dist_m:number = segment.distance;
                const segment_duration_s:number = segment.duration;

                if (trip.filters.dist_unit == "km") {
                    drive_dist_displays[segments_handled].innerHTML = Math.round(semgent_dist_m/1000).toString();
                } else {
                    drive_dist_displays[segments_handled].innerHTML = Math.round(meter_to_mi(semgent_dist_m)).toString();
                };
                drive_time_displays[segments_handled].innerHTML = sec_to_timeStrCOLON(segment_duration_s);

                segments_handled += 1
            };
        };
    };

};

export function display_route(trip:Trip_v2) {
    display_driveTimeDist(trip);
    clearLayer(window.routeLayer);
    displayRoute(window.mainTripPlannerMap, trip.directions);
    clearLayer(window.mainMapMarkerLayer);
    displayStopPins(trip);

    clearLayer(window.stayMarkerLayer);
    displayStayPins(trip);

    $("#onRouteDropdownBtn").removeClass("d-none");

    $("#onRouteDropdownBtn").off("click");
    $("#onRouteDropdownBtn").on("click", function() {
        $(this).removeClass("autoBreathingButton");
    });
};

function display_trip_text_updates(trip:Trip_v2) {
    $("#startStopTitle").html(
        titleCase_withStates(
            trip.legs[0].clusters[0].clusterTitle
        )
    );
    const lastLeg:Trip_leg_v2 = trip.legs[trip.legs.length - 1];
    $("#endStopTitle").html(
        titleCase_withStates(
            lastLeg.clusters[lastLeg.clusters.length - 1].clusterTitle
        )
    );

    let nStops:number = 0;
    for (let i:number=0;i<trip.legs.length;i++){nStops+=trip.legs[i].clusters.length};
    $("#nStops").html(nStops.toString());
    if (!trip.filters.driveDist) {
        trip.filters.driveDist = 300;
    };
};

function updateCheckboxAndTriggerChange(selector:string, checked:boolean) {
    $(selector).prop('checked', checked).trigger('change');
};

export function init_perLeg_routeOptions_listeners() {
    $("[per-leg-mile-setting]").find("button").off("click");
    $("[per-leg-mile-setting]").find("button").on("click", function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        const selectedLegsElement = event.target.closest('[perleg_routeoptions_selectedlegs]');
        if (!selectedLegsElement) {
            const menu = $(this).closest("[per-leg-mile-setting]").find(".dropdown-menu");
            menu.dropdown("toggle");

            $(document).off("click.dropdown-close");
            if (menu.hasClass("show")) {
                $("[per-leg-mile-setting]").find(".dropdown-menu").not(menu).dropdown("hide");

                $(document).on("click.dropdown-close", function(event) {
                    if (!menu[0].contains(event.target)) {
                        menu.dropdown("hide");
                        $(document).off("click.dropdown-close");
                    };
                });
            };
        };
    });

    $("[perLegRouting_legOption]").off("click");
    $("[perLegRouting_legOption]").on("click", function() {
        $("#recalculate").removeClass("disabled");

        const wrapper_el = $(this).closest("[per-leg-mile-setting]");

        const legIndex = this.getAttribute("leg");
        const selectedOption = document.createElement("div");
        selectedOption.className = "border border-primary rounded-pill d-flex gap-1 px-1 align-items-center";
        selectedOption.setAttribute("leg", legIndex);
        selectedOption.setAttribute("selectedLeg","");

        const selectedOptionText = document.createElement("div");
        selectedOptionText.className = "d-flex gap-1 overflow-hidden";
        selectedOptionText.innerHTML = this.innerHTML;

        const remBtn = document.createElement("i");
        remBtn.className = "ai-circle-x";
        remBtn.setAttribute("leg",legIndex);

        remBtn.addEventListener("click", function(event) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
            const wrapper_el = $(this).closest("[per-leg-mile-setting]");
            const legIndex = this.getAttribute("leg");
            $(`[perLegRouting_legOption][leg="${legIndex}"]`).removeClass("d-none");
            wrapper_el.find("[perLeg_routeOptions_selectedLegs]").find(`[leg="${legIndex}"]`).remove();
            if (wrapper_el.find("[perLeg_routeOptions_selectedLegs]").children().length == 0) {
                wrapper_el.find("[perLeg_routeOptions_emptyState]").show();
            };
        });

        selectedOption.append(selectedOptionText);
        selectedOption.append(remBtn);

        wrapper_el.find("[perLeg_routeOptions_emptyState]").hide();
        wrapper_el.find("[perLeg_routeOptions_selectedLegs]").append(selectedOption);
        $(`[perLegRouting_legOption][leg="${legIndex}"]`).addClass("d-none");

        const dropdown = $(this).closest("[per-leg-mile-setting]").find(".dropdown-menu");
        if (dropdown.children().length == 0) {
            dropdown.dropdown("hide");
        };
    });
};

function set_perLeg_routeOptions_display(trip:Trip_v2) {
    $("[perLeg_routeOptions_select]").html("");
    for (let i:number = 0; i < trip.queries.length; i++) {
        if (i + 1 >= trip.queries.length) {
            //this shouldn't be possible
            break;
        };
        const option = document.createElement("div");
        option.className = " d-flex gap-1";
        option.setAttribute("perLegRouting_legOption","")
        option.setAttribute("leg",i.toString());
        option.setAttribute("role","button");
        option.innerHTML = `<p class="mb-0 text-truncate text-nowrap">${titleCase_withStates(trip.queries[i])}</p><p class="mb-0">-</p><p class="mb-0 text-truncate text-nowrap">${titleCase_withStates(trip.queries[i+1])}</p>`
        $("[perLeg_routeOptions_select]").append(option);
    };

    init_perLeg_routeOptions_listeners();
};

export function set_filters_display(trip:Trip_v2) {
    if (!trip.filters.driveDist) {
        trip.filters.driveDist = 300;
    };
    $("#drive-dist").val(trip.filters.driveDist);

    updateCheckboxAndTriggerChange("#avoid-highways", trip.filters.avoidHighways);
    updateCheckboxAndTriggerChange("#avoid-tolls", trip.filters.avoidTolls);
    updateCheckboxAndTriggerChange("#avoid-tunnels", trip.filters.avoidTunnels);
    updateCheckboxAndTriggerChange("#avoid-ferries", trip.filters.avoidFerries);
    if (trip.filters.useFullDriveDist) {
        $("#driveDistOption > option#useFullDist").prop("selected", true);
        $("#driveDistOption > option#avgDist").prop("selected", false);
    } else {
        $("#driveDistOption > option#useFullDist").prop("selected", false);
        $("#driveDistOption > option#avgDist").prop("selected", true);
    };
    if (trip.filters.vehicleType == null) trip.filters.vehicleType = "rv";
    if (trip.filters.vehicleType == "rv") {
        $("#vehicleType >option#rv").prop("selected",true);
        $("#vehicleType >option#car").prop("selected",false);
    } else {
        $("#vehicleType >option#car").prop("selected",true);
        $("#vehicleType >option#rv").prop("selected",false);
    };

    set_perLeg_routeOptions_display(trip);

    if (trip.filters.avoidAreas) {
        $("#avoid-area-entries").html("");
        for(let i:number = 0; i < trip.filters.avoidAreas.length; i++) {
            const new_avoid_entry = $("<div avoid-area-entry-wrap=''>");
            new_avoid_entry.addClass("d-flex align-items-center justify-content-between p-2 border-bottom fs-lg");
            new_avoid_entry.attr("id", trip.filters.avoidAreas[i].id);
            new_avoid_entry.append($(`<div avoid-area-name="">${trip.filters.avoidAreas[i].name}</div>`));
            new_avoid_entry.append($("<i class='ai-trash fs-lg' role='button' rem-avoid-area-entry=''></i>"));
            new_avoid_entry.find("[rem-avoid-area-entry]").on("click", function() {
                remove_avoid_area(new_avoid_entry);
            });

            $("#avoid-area-entries").append(new_avoid_entry);
        };
    };
    if (trip.filters.avoidStates) {
        for (let i:number = 0; i < trip.filters.avoidStates.length; i++) {
            $(`input[type="checkbox"][id="avoid-${trip.filters.avoidStates[i]}"]`).prop("checked", true);
        }
    };

    $("#recalculate").addClass("disabled");
};

// export function init_reorder_tab(trip:Trip_v2) {
//     const reorderWrap = document.getElementById("reorderStopsWrap");
//     $(reorderWrap).html("");
//     let stopNum:number = 0;
//     for (let i:number = 0; i < trip.legs.length; i++) {
//         const leg:Trip_leg_v2 = trip.legs[i];
//         for (let j:number = 0; j < leg.clusters.length; j++) {
//             const cluster:Trip_Cluster_v2 = leg.clusters[j];
//             if (cluster.fromUserQuery) {
//                 let stopLabel:string;
//                 if (stopNum == 0) {
//                     stopLabel = "START"
//                 } else {
//                     stopLabel = `STOP ${stopNum}`;
//                 };
//                 $(reorderWrap).append($(mustache.render(reorderTabStop, {
//                     stopLabel: stopLabel,
//                     stopTitle: cluster.clusterTitle,
//                     legIndex: i,
//                     stopIndex: j
//                 })));
//                 stopNum += 1;
//             };
//         };
//     };

//     const sortable:Sortable = new Sortable(reorderWrap, {
//         selectedClass: "bg-primary",
//         avoidImplicitDeselect: false,
//         onSelect: function(evt) {
//         },
//         onDeselect: function(evt) {
//         },
//         onUpdate: function(evt) {
//             $("#confirm-reorder").removeClass("disabled");
//         }
//     })
// };

function init_reorder() {
    const container = document.getElementById("tripOverviewWrapper");

    const scrollableParent = document.getElementById("mainTripSidebar-scroll-el");

    const s = Sortable.create(container, {
        scroll: scrollableParent,

        handle: ".ai-reorder-dots",
        draggable: ".legWrapper",
        animation: 150,
        dragClass: "stop-reorder-drag",
        ghostClass: "stop-reorder-ghost",
        revertOnSpill: true,

        onStart: function (evt) {
            if (window.enlargedStopIcon != undefined) {
                shrinkIcon(window.enlargedStopIcon, null);
            };
            hide_tooltips();

            $(".suggested-stop-wrapper").addClass("d-none");
        },
        onEnd: function(evt) {
            const newOrder = $(container).children().map(function() {
                const stops = $(this).find(".userStop");
                const order:Array<{legIndex:number,stopIndex:number}>= [];
                stops.each(function(idx,el) {
                    const stopID = el.getAttribute("stopID");
                    const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
                    if (stopData == null) return;
                    order.push({legIndex:stopData.legIndex, stopIndex: stopData.stopIndex});
                });
                return order;
            }).toArray();
            const originalOrder = [...newOrder].sort((a,b) => {
                if (a.legIndex > b.legIndex) return 1;
                else if (a.legIndex < b.legIndex) return -1;
                else if (a.stopIndex > b.stopIndex) return 1;
                else if (a.stopIndex < b.stopIndex) return -1;
                return 0;
            });
            if (JSON.stringify(newOrder) == JSON.stringify(originalOrder)) {
                $(".suggested-stop-wrapper").removeClass("d-none");
                return;
            };
            show_map_loadingIcon("Recalculating your route");
            reorder_stops(window.tripPlannerCurrentTrip, newOrder).then(trip => {
                window.tripPlannerCurrentTrip = trip;
                display_trip(trip, !$("#stopPopout").is(":visible"));
                // $("#confirm-reorder").removeClass("disabled");
                hide_map_loadingIcon();

                $('[data-bs-toggle="tab"][href="#tripOverviewTab"]').tab("show");
            }).catch(e => {
                console.error(e);
                $("#confirm-reorder").removeClass("disabled");
                hide_map_loadingIcon();
            });
        }
    });
};

function display_notes(trip:Trip_v2) {
    for (let i = 0; i < trip.legs.length; i++) {
        for (let j = 0; j < trip.legs[i].clusters.length; j++) {
            const stop = trip.legs[i].clusters[j]
            if (stop.notes) {
                const container = document.querySelector(`[notes-container][stopID="${stop.stopID}"]`);
                if (!container) return;
                const shadowRoot = container.attachShadow({mode:'open'});
                shadowRoot.innerHTML = stop.notes;
            };
        };
    };
};

export function display_trip_html(trip:Trip_v2,directionsUpToDate:boolean) {
    $("#mainTripSidebar").collapse("show");
    $("#tripOverviewTab").html(trip.stopListHTML);

    if (trip.name) {
        $("#tripName").text(trip.name);
    }

    display_notes(trip);

    initializeTooltips();

    init_reorder();

    display_trip_text_updates(trip);
    if (directionsUpToDate) {
        display_driveTimeDist(trip);
    };
    set_filters_display(trip);

    // init_reorder_tab(trip);

    init_remWishes_listener();

    init_date_pickers();

    show_dates_warnings(trip);

    init_postSearch_listeners();

    $("[remove-stay]").on("click", function() {
        const stopID:string = this.getAttribute("stopID");
        const campID:number = parseInt($(this).attr("campID"));

        const stopData:{stop:Trip_Cluster_v2,legIndex:number,stopIndex:number}|null = get_stop_from_stopID(stopID,window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop:Trip_Cluster_v2 = stopData.stop;
        const legIndex:number = stopData.legIndex;
        const stopIndex:number = stopData.stopIndex;

        const removedCamp:Campground_Data|null = remove_stay_from_stop(stop, campID);
        if (removedCamp != null) {
            stop.altStops.push(removedCamp);
            display_potential_stays(window.tripPlannerCurrentTrip, stop, !stop.fromUserQuery);
        };

        send_removeStay(legIndex, stopIndex, campID);

        $("#stopPopout").find("#stopPopout_addedStays").find(`#${campID}`).remove();

        getTripHTML(window.tripPlannerCurrentTrip).then(tripHTML => {
            window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
            display_trip_html(window.tripPlannerCurrentTrip, false);
            document.dispatchEvent(new CustomEvent("directionsUpdateNeeded"));
        }).catch(e => {
            console.error(e);
        });
    });

    // if ($("#stopPopout").is(":visible")) {
    //     sync_stop_popout();
    // };

    if (window.openStopTabIds != undefined) {
        for (let i:number = 0; i < window.openStopTabIds.length; i++) {
            $(`[stopDetailsTabs] a[href="${window.openStopTabIds[i]}"]`).tab("show");
            $(`[stopDetailsTabs] a[href="${window.openStopTabIds[i]}"]`).addClass("is-shown");
            $(`[stopDetailsTabs] a[href="${window.openStopTabIds[i]}"]`).trigger("shown.bs.tab");

            const stopID = $(`[stopDetailsTabs] a[href="${window.openStopTabIds[i]}"]`).attr("stopID");
            $(`[stop_drive_stats][stopID="${stopID}"]`).addClass("d-none");

        };
    };
};

function block_click(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    $("#startTrial_blockInteraction").modal("show");
};

export async function display_trip(trip:Trip_v2, changeMapZoom:boolean) {
    if (window.featureFlags == undefined || window.featureFlags.freemiumAccess == undefined) {
		await getAllFeatureFlags();
	};
    const tp_trial_req = getCookie("tp-trial-req") == "t";
    if ((Number.isNaN(parseInt(window.GAsubLevel)) || parseInt(window.GAsubLevel) < 1)
         && tp_trial_req) {
        if (window.featureFlags.freemiumAccess.monthly_offer) {
            setTimeout(() => {
                $("#startMonthly_blockInteraction").modal("show");
            }, 2000);

        } else {
            try{
                window.dataLayer = window.dataLayer || [];
                const closeable:boolean = window.featureFlags.freemiumAccess.allow_modalBlocker_close == true;
                window.dataLayer.push({'event': 'trialReq-tp-interaction-block', 'interactionBlockParameters': {'closeable':closeable}});
            } catch (error){
                console.error(error.message)
            }
            setTimeout(() => {
                $("#startTrial_blockInteraction").modal("show");
            }, 2000);

            $("#startTrial_blockInteraction").on("hidden.bs.modal", () => {
                document.getElementById("tripPlannerPageWrap").removeEventListener("click", block_click, true);
                document.getElementById("tripPlannerPageWrap").addEventListener("click", block_click, true);
            });
        }
    } else if (window.GAsubLevel == undefined && window.featureFlags.freemiumAccess.block_anon_usage) {
        try{
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({'event': 'anon-tp-interaction-block'});
        } catch (error){
            console.error(error.message)
        }
        setTimeout(() => {
            $("#signUp_blockInteraction").modal("show");
        }, 2000);
    };

    $("#mobile_tabs").removeClass("d-none");
    $("#mobileTrip_aboveTabs").removeClass("d-none");
    $('a[href="#tripTab"]').tab("show");

    $("#personalGenieBtn").removeClass("d-none");
    if (getCookie("g-msg").length == 0) {
        $("#personalGenie-welcomeMsg").removeClass("d-none");

        $("#close-personal-genie-msg").on("click", function() {
            $("#personalGenie-welcomeMsg").addClass("d-none");
            setCookie("g-msg","t","", null);
        });

        setTimeout(() => {
            $("#personalGenie-welcomeMsg").addClass("d-none");
            setCookie("g-msg","t","", null);
        }, 180000);
    };

    display_trip_html(trip, true);

    clearLayer(window.routeLayer);
    display_route(trip);

    clearLayer(window.mainMapMarkerLayer);
    displayStopPins(trip);

    if (changeMapZoom) center_map(window.mainTripPlannerMap, trip);

    wisepops("event", "new-tp-video-notMemberTrigger");
};

function remWishes_listener() {
    const wishesIdx:number = parseInt(this.getAttribute("wishesIdx"));
    const stopID = this.getAttribute("stopID");
    const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
    if (stopData == null) return;
    const stop = stopData.stop;
    const legIndex = stopData.legIndex;
    const stopIndex = stopData.stopIndex;

    if (stop.wishes == undefined || stop.wishes == null || wishesIdx >= stop.wishes.length) return;
    stop.wishes.splice(wishesIdx, 1);
    send_updateTripWishes([{
        legIndex:legIndex,
        stopIndex:stopIndex,
        wishes: stop.wishes
    }]);
    $(`[wishId="${legIndex}-${stopIndex}-${wishesIdx}"]`).remove();

    // if ($("#stopWishesDisplay").children().length == 0) {
    //     $("#stopWishesDisplay_wrapper").hide();
    // };

    getTripHTML(window.tripPlannerCurrentTrip).then(tripHTML => {
        window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
        display_trip_html(window.tripPlannerCurrentTrip, true);
    });
};
export function init_remWishes_listener() {
    $("[remwishes]").off("click");
    $("[remwishes]").on("click", remWishes_listener);
};